import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCustomersByBusinessId } from '../services/getCustomersByBusinessId.service';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const loadCustomersByBusinessId = createAsyncThunk(
  'customers/loadCustomersByBusinessId',
  async (businessId, { getState }) => {

    const state = getState();
    const activeEmployerInfo = selectUserActiveEmployerInfo(state);
    const response = await getCustomersByBusinessId(businessId, activeEmployerInfo);

    return response;
  }
);
